import { CATEGORIES } from "@/mocks/content";

export default function Categories() {
  return (
    <section id="category" className="w-full bg-background-100 py-16 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="mb-2 text-sm font-bold tracking-[0.25em] text-primary-600">FIELDS · 垂直追踪</p>
            <h2 className="font-heading text-2xl font-black text-foreground-950 md:text-4xl">按领域围观幕后</h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              从一份合约到一场综艺，从剧组片场到数据后台，我们按娱乐圈的真实分工追踪每一条线索的去向。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {CATEGORIES.map((cat) => (
            <article
              key={cat.key}
              className="group relative flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 p-6 transition-all hover:-translate-y-1 hover:border-primary-300"
            >
              <div className="mb-4 flex items-start justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-md bg-secondary-100 text-xl text-primary-600 transition-colors group-hover:bg-primary-100">
                  <i className={cat.icon}></i>
                </span>
                <span className="font-heading text-xs font-bold tracking-[0.2em] text-foreground-300">
                  {cat.en}
                </span>
              </div>
              <h3 className="font-heading text-lg font-black text-foreground-950">{cat.name}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{cat.desc}</p>
              <a
                href="#latest"
                className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
              >
                <i className="ri-crosshair-2-line"></i> 追踪该领域
                <i className="ri-arrow-right-line ml-auto transition-transform group-hover:translate-x-1"></i>
              </a>
            </article>
          ))}

          <article className="flex flex-col justify-center rounded-lg border border-dashed border-primary-300 bg-primary-100/50 p-6">
            <h3 className="font-heading text-lg font-black text-primary-800">你站的是哪条线？</h3>
            <p className="mt-2 text-sm leading-relaxed text-primary-900">
              亲眼所见的片场、亲耳听到的博弈、随手拍下的时间线——你的线索可能正是我们缺失的一环。
            </p>
            <a
              href="#subscribe"
              className="mt-5 inline-flex w-fit items-center justify-center whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-fill mr-1.5"></i> 匿名投稿
            </a>
          </article>
        </div>
      </div>
    </section>
  );
}